import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { Accuracy, Listing } from '@smg-real-estate/hg-rets-schema';

const SUPPORTED_TRAVEL_TIME_COUNTRIES = ['geo-country-switzerland', 'geo-country-liechtenstein'];

export async function ensureGoogleLoaded(apiKey?: string): Promise<void> {
  if (!apiKey) {
    throw new Error('Google Maps API key is required');
  }

  if (window?.google?.maps) {
    return;
  }

  setOptions({ key: apiKey });
  await importLibrary('places');
}

export const getPlaceDetailsAsync = async (
  token: google.maps.places.AutocompleteSessionToken,
  placeId: string,
  service: google.maps.places.PlacesService,
): Promise<google.maps.places.PlaceResult | null> => {
  return new Promise((resolve, reject) => {
    service.getDetails(
      {
        placeId: placeId,
        fields: ['geometry'],
        sessionToken: token,
      },
      (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(new Error(`Place details fetch failed: ${status}`));
        }
      },
    );
  });
};

export const isHighAccurateGeocoordinates = (listing: Listing): boolean => {
  return (
    !!listing.address?.postalCode &&
    !!listing.address?.street &&
    !!listing.address?.geoCoordinates &&
    listing.address?.geoCoordinates.accuracy === Accuracy.High
  );
};

export const isListingSupportedByTravelTime = (listing: Listing): boolean => {
  const geoTags = listing.address?.geoTags ?? [];

  return (
    isHighAccurateGeocoordinates(listing) &&
    SUPPORTED_TRAVEL_TIME_COUNTRIES.some((geoTag) => geoTags.includes(geoTag))
  );
};
